var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "pay_success" }, [
    _c("img", {
      staticClass: "success_img",
      attrs: { src: "/static/image/payerror.png" }
    }),
    _vm._v(" "),
    _c("p", { staticClass: "success_text" }, [_vm._v("支付失败")]),
    _vm._v(" "),
    _c("p", { staticClass: "error_content" }, [
      _vm._v("您的卡余额不足，请更换支付方式")
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "success_btn", on: { click: _vm.handleComplete } },
      [_vm._v("完成")]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-18c5fa48", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18c5fa48","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/payError/index.vue
// module id = null
// module chunks = 